<div [formGroup]="form">
	<nz-form-item *ngIf="inline == false">
		<nz-form-label [nzSpan]="10"  [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-control [nzSpan]="10"  [nzAutoTips]="wrapper.autoTips">
			<nz-time-picker [formControlName]="toControlKey(wrapper.element)"  [nzDisabled]="readonly"></nz-time-picker>
		</nz-form-control>
	</nz-form-item>
	<nz-form-item *ngIf="inline == true">
		<nz-form-label [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<nz-time-picker [formControlName]="toControlKey(wrapper.element)" [nzDisabled]="readonly"></nz-time-picker>
		</nz-form-control>
	</nz-form-item>
</div>
